import { createModule } from '../actions/utils';
import { SERVICE_ENDPOINT } from '../apis/constants';

const GetFavoriteEntity = createModule({
  base: 'GET_FAVORITE_ENTITY', apiDetails: SERVICE_ENDPOINT.GET_FAVORITE_ENTITY,
});

const AddFavoriteEntity = createModule({
  base: 'ADD_FAVORITE_ENTITY', apiDetails: SERVICE_ENDPOINT.ADD_FAVORITE_ENTITY, errors: { defaultError: true, customError: '' }, enableNotification: true, runCallbackOnError: true,
});

const RemoveFavoriteEntity = createModule({
  base: 'REMOVE_FAVORITE_ENTITY', apiDetails: SERVICE_ENDPOINT.REMOVE_FAVORITE_ENTITY, errors: { defaultError: true, customError: '' }, enableNotification: true, runCallbackOnError: true,
});

export { GetFavoriteEntity, AddFavoriteEntity, RemoveFavoriteEntity };
